// @flow
import 'meteor-client'
import './global'
import { ConfirmProvider } from 'material-ui-confirm'

import React, { useState, useEffect, Suspense } from 'react'
import { Meteor } from 'meteor/meteor'
import { Router, Switch } from 'react-router-dom'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'
import * as moment from 'moment'
import { IntlProvider } from 'react-intl'
import MomentUtils from '@date-io/moment'
import { PersistGate } from 'redux-persist/lib/integration/react'
import { ToastContainer } from 'react-toastify'
import ScrollRestoration from 'react-scroll-restoration'

import * as Sentry from '@sentry/react'
import ConditionnalRoute from './components/ConditionnalRoute'
import LoaderData from './LoaderData'
import Layout from './components/Layout'
import getRoutes from './routes'

import CurrentLocale from './CurrentLocale'
import 'moment/locale/fr'
import MainLoader from './components/loadings/MainLoader'

import history from './history'

import PackageJson from '../package.json'
import { GlobalStateProvider, useGlobalState, persistor } from './store'

if (!global.Intl) {
  require('intl')
  require('intl/locale-data/jsonp/en')
  require('intl/locale-data/jsonp/fr')
}

// $FlowFixMe
if (!Intl.RelativeTimeFormat) {
  // $FlowFixMe
  require('@formatjs/intl-relativetimeformat/polyfill')
  // $FlowFixMe
  require('@formatjs/intl-relativetimeformat/dist/locale-data/fr') // Add locale data for fr
}

if (process.env.NODE_ENV === 'production')
  Sentry.init({
    dsn: 'https://2599f38f75e94d898a581c4bed13b403@o395580.ingest.sentry.io/5250572',
    environment: Meteor.absoluteUrl(),
    release: 'calwebapp@' + PackageJson.version,
  })

const { lang = 'fr' } = JSON.parse(localStorage.getItem('callalawyer') || '{}') || {}

const fetchTranslate = async (setMessages) => {
  const translate = await Meteor.promise('getTranslations')

  setMessages(translate)
}

const Routing = () => (
  <Suspense fallback={<MainLoader open />}>
    <Switch>
      {getRoutes().map(
        ({ component, condition, path, redirect, extraProps, mailto = {}, titlePage }) => (
          <ConditionnalRoute
            key={path}
            exact
            path={path}
            condition={condition}
            component={component}
            redirect={redirect}
            computedProps={extraProps}
            mailto={mailto}
            titlePage={titlePage}
          />
        )
      )}
    </Switch>
  </Suspense>
)

const App = () => {
  const [messages, setMessages] = useState({})
  const [OpenLoader] = useGlobalState('loader')

  useEffect(() => {
    fetchTranslate(setMessages)
    moment.locale(lang)
  }, [])

  if (Object.keys(messages).length === 0) return <MainLoader open />

  return (
    <IntlProvider
      locale={lang}
      messages={!!messages && Object.keys(messages).length > 0 ? messages[lang] : {}}
      onError={() => {
        /* no display error ...please, stop this spam ! */
      }}
    >
      <GlobalStateProvider>
        <CurrentLocale />
        <ToastContainer
          position="bottom-right"
          autoClose={7000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
        <MainLoader open={OpenLoader.open || Object.keys(messages).length === 0} />
        <PersistGate loading={<MainLoader open />} persistor={persistor}>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <ConfirmProvider>
              <Router history={history}>
                <ScrollRestoration />
                <LoaderData>
                  <Layout>
                    <Routing />
                  </Layout>
                </LoaderData>
              </Router>
            </ConfirmProvider>
          </MuiPickersUtilsProvider>
        </PersistGate>
      </GlobalStateProvider>
    </IntlProvider>
  )
}

export default App
